import { VoidFunctionComponent } from "react";
import { NavContentProps } from "./NavContent.props";
import styles from "./NavContent.module.scss";
import classNames from "classnames";
import { NavTitle } from "../NavTitle";
import { NavDescription } from "../NavDescription";

/**
 * The navigation item content component.
 */
export const NavContent: VoidFunctionComponent<NavContentProps> = (props: NavContentProps) => {
  const { className, title, description, testId } = props;

  const navCardClasses = classNames("nav-content", styles.navContent, className);

  return (
    <div className={navCardClasses}>
      <NavTitle testId={testId}>{title}</NavTitle>
      <NavDescription testId={testId}>{description}</NavDescription>
    </div>
  );
};
